(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
class RichTextAddToCart extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    this.variantId = this.dataset.variantId;

    if (this.button && this.variantId) {
      this.registerListener();
    }
  }

  registerListener() {
    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      customAddToCart(this.variantId, 1);
    });
  }
}

customElements.define('rich-text-add-to-cart', RichTextAddToCart);

  } catch(e) { console.error(e); }
})();
})();
